angular.module('dnecom')
    .controller('ProductProcessManageController', ["$scope", "$http", "StoreUtils", "ProductUtils", "notifications", "wizardModal", function ProductProcessManageController($scope, $http, StoreUtils, ProductUtils, notifications, wizardModal) {
        $scope.statuses = TemplateData.value('statuses');
        $scope.isFeaturedUpdating = false;

        $scope.delete = function () {
            ProductUtils
                .delete($scope.store, $scope.product)
                .then(function () {
                    $scope.setOriginalProduct($scope.product);
                    window.location = Routing.generate('products_list', {id: $scope.store.id});
                })
        };

        $scope.previewProduct = function () {
            let path = Routing.generate('stores_fe_product', {
                productId: $scope.originalProduct.id,
                hash: $scope.originalProduct.hash
            });

            if ($scope.originalProduct.slug) {
                path = Routing.generate('stores_fe_product_slug', {
                    productSlug: $scope.originalProduct.slug,
                    hash: $scope.originalProduct.hash
                });
            }

            window.open(StoreUtils.getUrl($scope.store, path), '_blank');
        };

        $scope.featureProduct = function () {
            if ($scope.isFeaturedUpdating) {
                return;
            }

            $scope.isFeaturedUpdating = true;

            $http.put(
                Routing.generate('products_feature', { store: $scope.store.id, product: $scope.product.id }),
                { featured : !$scope.product.featured }
            )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    $scope.product.featured = !$scope.product.featured;
                    notifications.success('Product has been marked as ' + ($scope.product.featured ? 'featured' : 'standard' ));

                }, function (response) {
                    notifications.danger('Request error.');
                })
                .finally(function () {
                    $scope.isFeaturedUpdating = false;
                });
        };

        $scope.toggleDirectlyToCheckout = function () {
            $scope.product.directlyToCheckout = ! $scope.product.directlyToCheckout;
            if (!$scope.product.directlyToCheckout) {
                $scope.product.directlyToCheckoutPopup = false;
            }
        };

        $scope.directlyToCheckoutPopupEdit = function () {
            var modal = wizardModal.open({
                'templateUrl': 'directlyToCheckoutEdit.html',
                'controller':'DirectlyToCheckoutEditController' ,
                'size': 'lg',
                resolve: {
                    product: $scope.product
                }
            });

            modal.result.then(function () {
                $scope.save($scope.form);
            });
        };
    }]);

